export const TG_URL = 'https://www.makemytrip.com/promos/trains-trip-guarantee.html?popup=noShow&detail_image=no';
export const TRIP_GUARANTEE = 'Trip Guarantee';
export const TG_TEXT_LINK = 'Learn More';
export const TG_TEXT = '3x refund';
export const WAITLISTED = 'on waitlisted ticket';
